/* TestHelden v3 · Produktseite: Galerie (Wischen, Pfeile, Daumen) und Journey (9:16, Pfeile, Großansicht). */
(function () {
  // Pagespeed 18.10.2026: Bilder mit data-th3-src/-srcset (Galerie ab Bild 2, Journey ab Karte 4) bekommen ihre Quelle erst
  // bei der ersten Interaktion mit dem Bereich (Hover, Tippen, Wischen, Fokus) oder 4 s nach dem load-Ereignis.
  // Querscroller liegen sonst komplett im Lazy-Load-Radius und luden alles sofort.
  function spaetLaden(bereich, scroller) {
    var geladen = false;
    function nachladen() {
      if (geladen) return;
      geladen = true;
      bereich.querySelectorAll('img[data-th3-src]').forEach(function (img) {
        img.srcset = img.getAttribute('data-th3-srcset') || '';
        img.src = img.getAttribute('data-th3-src');
        img.removeAttribute('data-th3-src');
        img.removeAttribute('data-th3-srcset');
      });
    }
    ['pointerenter', 'pointerdown', 'touchstart', 'focusin', 'keydown'].forEach(function (n) { bereich.addEventListener(n, nachladen, { once: true, passive: true }); });
    scroller.addEventListener('scroll', nachladen, { once: true, passive: true });
    function spaeter() { setTimeout(nachladen, 4000); }
    if (document.readyState === 'complete') spaeter(); else window.addEventListener('load', spaeter, { once: true });
  }
  function galerie(g) {
    var buehne = g.querySelector('[data-th3-buehne]');
    var bilder = g.querySelectorAll('[data-th3-bild]');
    var daumen = g.querySelectorAll('[data-th3-daumen]');
    if (!buehne || !bilder.length) return;
    // Bilder 2+ tragen data-th3-src/-srcset: erst bei der ersten Interaktion oder 4 s nach dem Laden echte Quellen setzen
    spaetLaden(g, buehne);
    function aktuell() { return Math.round(buehne.scrollLeft / buehne.clientWidth); }
    function zu(i) { i = Math.max(0, Math.min(bilder.length - 1, i)); buehne.scrollTo({ left: i * buehne.clientWidth, behavior: 'smooth' }); }
    function markieren() { var i = aktuell(); daumen.forEach(function (d, k) { d.classList.toggle('is-aktiv', k === i); d.setAttribute('aria-selected', k === i ? 'true' : 'false'); }); }
    daumen.forEach(function (d, k) { d.addEventListener('click', function () { zu(k); }); });
    var z = g.querySelector('[data-th3-zurueck]'), w = g.querySelector('[data-th3-weiter]');
    if (z) z.addEventListener('click', function () { zu(aktuell() - 1); });
    if (w) w.addEventListener('click', function () { zu(aktuell() + 1); });
    buehne.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { zu(aktuell() + 1); e.preventDefault(); } if (e.key === 'ArrowLeft') { zu(aktuell() - 1); e.preventDefault(); } });
    var t; buehne.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(markieren, 60); }, { passive: true });
    markieren();
  }
  function journey(j) {
    var liste = j.querySelector('[data-th3-j-liste]');
    if (!liste) return;
    spaetLaden(j, liste);
    function schritt(r) { var k = liste.querySelector('li'); var b = k ? k.getBoundingClientRect().width + 12 : 160; liste.scrollBy({ left: r * b * 2, behavior: 'smooth' }); }
    var z = j.querySelector('[data-th3-j-zurueck]'), w = j.querySelector('[data-th3-j-weiter]');
    if (z) z.addEventListener('click', function () { schritt(-1); });
    if (w) w.addEventListener('click', function () { schritt(1); });
  }
  /* Story-Viewer im Instagram-Stil: Fortschrittsbalken, Autoplay, Tippen links/rechts, Halten pausiert, Pfeiltasten, Esc. */
  var DAUER = 6000;
  function story() {
    var st = document.querySelector('[data-th3-story]'); if (!st) return;
    var karten = [].slice.call(document.querySelectorAll('[data-th3-story-oeffnen]'));
    if (!karten.length) return;
    var bilder = karten.map(function (k) { return { src: k.getAttribute('data-th3-story-bild'), alt: (k.querySelector('img') || {}).alt || '' }; });
    var img = st.querySelector('[data-th3-story-img]'), balken = st.querySelectorAll('[data-th3-story-balken] i'), zaehler = st.querySelector('[data-th3-story-zaehler]');
    var pauseKnopf = st.querySelector('[data-th3-story-pause]');
    var i = 0, start = 0, rest = DAUER, timer = null, pausiert = false, zuletzt = null;
    function fuellen() { balken.forEach(function (b, k) { b.style.transition = 'none'; b.style.width = k < i ? '100%' : '0%'; }); }
    function laufen() {
      clearTimeout(timer); start = Date.now();
      var b = balken[i]; if (b) { b.offsetWidth; b.style.transition = 'width ' + rest + 'ms linear'; b.style.width = '100%'; }
      timer = setTimeout(weiter, rest);
    }
    function zeigen(n) {
      if (n < 0) n = 0; if (n >= bilder.length) { zu(); return; }
      i = n; rest = DAUER; img.src = bilder[i].src; img.alt = bilder[i].alt; zaehler.textContent = (i + 1) + ' / ' + bilder.length;
      if (bilder[i + 1]) { var v = new Image(); v.src = bilder[i + 1].src; }
      fuellen(); if (!pausiert) laufen();
    }
    function weiter() { zeigen(i + 1); }
    function zurueck() { zeigen(i - 1); }
    function anhalten() { if (pausiert) return; pausiert = true; clearTimeout(timer); rest = Math.max(300, rest - (Date.now() - start)); var b = balken[i]; if (b) { var w = getComputedStyle(b).width; b.style.transition = 'none'; b.style.width = w; } pauseKnopf.innerHTML = pauseKnopf.getAttribute('data-play') || pauseKnopf.innerHTML; pauseKnopf.setAttribute('aria-label', 'Abspielen'); }
    function fortsetzen() { if (!pausiert) return; pausiert = false; pauseKnopf.innerHTML = pauseKnopf.getAttribute('data-pause'); pauseKnopf.setAttribute('aria-label', 'Pause'); laufen(); }
    pauseKnopf.setAttribute('data-pause', pauseKnopf.innerHTML);
    pauseKnopf.setAttribute('data-play', '<svg class="th3-ic" viewBox="0 0 24 24" aria-hidden="true"><path d="M7 4.5v15l12-7.5z" fill="currentColor"/></svg>');
    function auf(n, von) { zuletzt = von; st.hidden = false; document.documentElement.classList.add('th3-story-offen'); pausiert = false; zeigen(n); st.querySelector('[data-th3-story-zu]').focus({ preventScroll: true }); }
    function zu() { clearTimeout(timer); st.hidden = true; document.documentElement.classList.remove('th3-story-offen'); if (zuletzt) zuletzt.focus({ preventScroll: true }); }
    karten.forEach(function (k, n) { k.addEventListener('click', function () { auf(n, k); }); });
    st.querySelectorAll('[data-th3-story-weiter]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); if (halt) return; weiter(); }); });
    st.querySelectorAll('[data-th3-story-zurueck]').forEach(function (b) { b.addEventListener('click', function (e) { e.stopPropagation(); if (halt) return; zurueck(); }); });
    st.querySelector('[data-th3-story-zu]').addEventListener('click', zu);
    pauseKnopf.addEventListener('click', function (e) { e.stopPropagation(); pausiert ? fortsetzen() : anhalten(); });
    st.addEventListener('click', function (e) { if (e.target === st) zu(); });
    // Gedrückt halten pausiert (wie Instagram); kurzes Tippen blättert
    var halt = false, haltTimer = null, rahmen = st.querySelector('.th3-story__rahmen');
    rahmen.addEventListener('pointerdown', function (e) { if (e.target.closest('button:not(.th3-story__zone)')) return; halt = false; haltTimer = setTimeout(function () { halt = true; anhalten(); }, 220); });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) { rahmen.addEventListener(ev, function () { clearTimeout(haltTimer); if (halt) { fortsetzen(); setTimeout(function () { halt = false; }, 50); } }); });
    document.addEventListener('keydown', function (e) {
      if (st.hidden) return;
      if (e.key === 'ArrowRight') { weiter(); e.preventDefault(); } else if (e.key === 'ArrowLeft') { zurueck(); e.preventDefault(); }
      else if (e.key === 'Escape') { zu(); } else if (e.key === ' ') { pausiert ? fortsetzen() : anhalten(); e.preventDefault(); }
    });
    document.addEventListener('visibilitychange', function () { if (!st.hidden) { document.hidden ? anhalten() : fortsetzen(); } });
  }
  function ki() {
    document.addEventListener('click', function (e) {
      var k = e.target.closest('[data-th3-ki-knopf]');
      document.querySelectorAll('[data-th3-ki-knopf][aria-expanded="true"]').forEach(function (o) { if (o !== k) { o.setAttribute('aria-expanded', 'false'); o.nextElementSibling.hidden = true; } });
      if (!k) return;
      e.preventDefault(); e.stopPropagation();
      var auf = k.getAttribute('aria-expanded') !== 'true'; k.setAttribute('aria-expanded', auf ? 'true' : 'false'); k.nextElementSibling.hidden = !auf;
    });
  }
  function zurPaketwahl() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href="#th-paketwahl"]'); if (!a) return;
      var z = document.getElementById('th-paketwahl'); if (!z) return;
      e.preventDefault();
      var top = z.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top: top, behavior: 'smooth' });
      var r = z.querySelector('input:checked') || z.querySelector('input'); if (r) setTimeout(function () { r.focus({ preventScroll: true }); }, 600);
    });
  }
  // Variantenbild (27.10.2026): Bei Paketwahl zeigt die Galerie das Bild der Variante (data-th3-bild).
  // Buch-Zusatz: Mit Haken gilt die Buch-Variante des Pakets (data-th3-buch-id, eigene ?variant=-ID für Google):
  // Bild, Preis und URL wechseln, beim Absenden ersetzt das formdata-Ereignis die id. Status "test": nur mit
  // ?buchtest=1 sichtbar (merkt sich die Sitzung) und ohne Wirkung auf Absenden und URL.
  function paketBild() {
    var form = document.querySelector('[data-th-v2-form]');
    var box = document.querySelector('.th3-galerie__bild--box img');
    if (!form || !box) return;
    var daumen = document.querySelector('[data-th3-daumen] img');
    var buehne = document.querySelector('[data-th3-buehne]');
    var buch = form.querySelector('[data-th3-buch]');
    var check = buch && buch.querySelector('[data-th3-buch-check]');
    var test = buch && buch.getAttribute('data-status') === 'test';
    if (buch && test) {
      var an = /[?&]buchtest=1/.test(location.search) || (check && check.checked);
      try { if (an) sessionStorage.setItem('th3-buchtest', '1'); else an = sessionStorage.getItem('th3-buchtest') === '1'; } catch (e) {}
      if (an) buch.hidden = false;
    }
    function mitBreite(u, w) { return u.replace(/([?&])width=\d+/, '$1width=' + w).replace(/^([^?]*)$/, '$1?width=' + w).replace(/(\?v=\d+)$/, '$1&width=' + w); }
    function preisFormat(cents) { return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: cents % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; }
    function zustand() {
      var r = form.querySelector('[data-th-pkg-input]:checked');
      var mitBuch = !!(r && check && buch && !buch.hidden && check.checked && r.getAttribute('data-th3-buch-id'));
      return { r: r, mitBuch: mitBuch };
    }
    var startBild = box.getAttribute('src');
    function setzen(nachWahl) {
      // 02.11.2026: Haken nur bei Paketen mit Buch-Variante (Premium mit eBook inklusive bekommt keinen)
      if (buch && !test && buch.hasAttribute('data-th3-buch-je-paket')) { var rb = form.querySelector('[data-th-pkg-input]:checked'); buch.hidden = !(rb && rb.getAttribute('data-th3-buch-id')); }
      var z = zustand(), r = z.r;
      if (!r) return;
      var url = z.mitBuch ? (r.getAttribute('data-th3-buch-bild') || r.getAttribute('data-th3-bild')) : r.getAttribute('data-th3-bild');
      if (url) {
        var neu = mitBreite(url, 1200);
        if (box.getAttribute('src').split('?')[0] !== neu.split('?')[0]) {
          box.removeAttribute('srcset'); box.setAttribute('src', neu);
          box.setAttribute('alt', (z.mitBuch ? r.getAttribute('data-th3-buch-titel') : r.getAttribute('data-th3-bild-alt')) || box.getAttribute('alt'));
          if (daumen) daumen.setAttribute('src', mitBreite(url, 180));
          if (nachWahl && buehne && buehne.scrollLeft > 0) buehne.scrollTo({ left: 0, behavior: 'smooth' });
        }
      }
      if (buch && !buch.hidden) {
        var cents = parseInt((z.mitBuch ? r.getAttribute('data-th3-buch-preis') : r.getAttribute('data-price')) || '0', 10);
        var box2 = form.closest('[data-th-buy]') || document;
        box2.querySelectorAll('[data-th-buy-price]').forEach(function (el) { el.textContent = preisFormat(cents); });
        if (!test && nachWahl && window.history && window.history.replaceState) {
          try { var u = new URL(window.location.href); u.searchParams.set('variant', z.mitBuch ? r.getAttribute('data-th3-buch-id') : r.value); window.history.replaceState({}, '', u.toString()); } catch (e) {}
        }
      }
    }
    form.addEventListener('formdata', function (e) {
      var z = zustand();
      if (z.mitBuch && !test) e.formData.set('id', z.r.getAttribute('data-th3-buch-id'));
    });
    form.addEventListener('change', function (e) {
      if (e.target.matches('[data-th-pkg-input]') || e.target.matches('[data-th3-buch-check]')) setTimeout(function () { setzen(true); }, 0);
    });
    void startBild;
    setzen(false);
  }

  // Zusatzprodukt per Haken (03.11.2026, Berichtsheft-Assistent): Preis zeigt Paket + Zusatz, beim Absenden gehen
  // beide Artikel als items[] an /cart/add. Läuft nach paketBild, damit dessen formdata-Tausch (Buch-Variante) zuerst greift.
  function zusatz() {
    var form = document.querySelector('[data-th-v2-form]');
    var check = form && form.querySelector('[data-th3-addon-check]');
    if (!check) return;
    var wrap = check.closest('[data-th3-addon]');
    function fmt(c) { return (c / 100).toLocaleString('de-DE', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; }
    function basis() {
      var r = form.querySelector('[data-th-pkg-input]:checked');
      if (!r) return parseInt(wrap.getAttribute('data-basis-cents') || '0', 10);
      var buch = form.querySelector('[data-th3-buch]'), bc = buch && buch.querySelector('[data-th3-buch-check]');
      var mitBuch = buch && !buch.hidden && buch.getAttribute('data-status') !== 'test' && bc && bc.checked && r.getAttribute('data-th3-buch-preis');
      return parseInt((mitBuch ? r.getAttribute('data-th3-buch-preis') : r.getAttribute('data-price')) || '0', 10);
    }
    function preis() {
      var c = basis() + (check.checked ? parseInt(check.getAttribute('data-preis-cents') || '0', 10) : 0);
      var box = form.closest('[data-th-buy]') || document;
      box.querySelectorAll('[data-th-buy-price]').forEach(function (el) { el.textContent = fmt(c); });
      document.querySelectorAll('[data-th-sticky-value]').forEach(function (el) { el.textContent = fmt(c); });
    }
    form.addEventListener('change', function () { setTimeout(preis, 20); });
    form.addEventListener('formdata', function (e) {
      if (!check.checked) return;
      var fd = e.formData, id = fd.get('id');
      if (!id) return;
      var props = [];
      fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m) props.push([m[1], v]); });
      props.forEach(function (p) { fd.delete('properties[' + p[0] + ']'); fd.set('items[0][properties][' + p[0] + ']', p[1]); });
      fd.delete('id'); fd.delete('quantity');
      fd.set('items[0][id]', id); fd.set('items[0][quantity]', '1');
      fd.set('items[1][id]', check.getAttribute('data-id')); fd.set('items[1][quantity]', '1');
      fd.set('items[1][properties][_th_upsell]', 'bump');
      fd.set('items[1][properties][_th_upsell_art]', 'zusatz_pdp');
      fd.set('items[1][properties][_th_upsell_von]', check.getAttribute('data-von') || '');
    });
    if (check.checked) preis();
  }

  function init() { ki(); story(); zurPaketwahl(); paketBild(); zusatz(); document.querySelectorAll('[data-th3-galerie]').forEach(galerie); document.querySelectorAll('[data-th3-journey]').forEach(journey); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
